// Export the trpc client configured for Vite
export { trpc as api } from "../lib/trpc"

/**
 * Get the API base URL based on environment
 */
export function getBaseUrl(forceAbsolute = false): string {
  // In browser, use relative URL unless forced absolute
  if (typeof window !== "undefined" && !forceAbsolute) {
    return ""
  }

  // For absolute URLs or SSR
  if (import.meta.env.VITE_VERCEL_URL) {
    return `https://${import.meta.env.VITE_VERCEL_URL}`
  }

  // Development fallback
  if (import.meta.env.DEV) {
    return "http://localhost:8787"
  }

  // Production fallback
  return "https://vidmax.ai"
}
